import { all, call, takeLatest } from 'redux-saga/effects';

import { GIFTS_ACTION_TYPES } from 'store/actions/gifts.actions';
import {
  createGift,
  createGiftsCategory,
  deleteGiftsCategory, editGift,
  editGiftsCategory, loadGifts,
  loadGiftsCategories
} from 'api/gifts';
import { getRangeDate } from 'utils/dateHelpers';
import { getRange } from 'utils/rangeHelpers';

function* loadGiftsCategoriesFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(loadGiftsCategories, payload)
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* createGiftsCategoryFlow({ payload, resolve, reject }) {
  try {
    const {data} = yield call(createGiftsCategory, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* deleteGiftsCategoryFlow({ payload, resolve, reject }) {
  try {
    const {data} = yield call(deleteGiftsCategory, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* editGiftsCategoryFlow({ payload, resolve, reject }) {
  try {
    const {data} = yield call(editGiftsCategory, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* createGiftFlow({ payload, resolve, reject }) {
  try {
    const {data} = yield call(createGift, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* editGiftFlow({ payload, resolve, reject }) {
  try {
    const {data} = yield call(editGift, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* loadGiftsFlow({ payload, resolve, reject }) {
  try {
    const { packagePrice, updatedAt, price, ...rest } = payload;
    let filters = rest;
    if (updatedAt) {
      filters = {
        ...filters,
        ...getRangeDate('updatedAt', updatedAt),
      }
    }
    if (packagePrice) {
      filters = {
        ...filters,
        ...getRange('packagePrice', packagePrice)
      }
    }
    if (price) {
      filters = {
        ...filters,
        ...getRange('price', price)
      }
    }
    const {data} = yield call(loadGifts, filters)
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

export default function* () {
  yield all([
    takeLatest(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_LOAD, loadGiftsCategoriesFlow),
    takeLatest(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_CREATE, createGiftsCategoryFlow),
    takeLatest(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_DELETE, deleteGiftsCategoryFlow),
    takeLatest(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_EDIT, editGiftsCategoryFlow),
    takeLatest(GIFTS_ACTION_TYPES.GIFTS_CREATE, createGiftFlow),
    takeLatest(GIFTS_ACTION_TYPES.GIFTS_EDIT, editGiftFlow),
    takeLatest(GIFTS_ACTION_TYPES.GIFTS_LOAD, loadGiftsFlow),
  ])
}